import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { EnvironmentService } from 'src/app/environment/environment.service';

@Component({
    selector: 'uploader',
    templateUrl: './uploader.component.html',
    styleUrls: ['./uploader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UploaderComponent {
  @Input('isSingleton') isSingleton: boolean = true;
  @Input('useName') useName: string = 'file';
  @Input('previewImage') previewImage: boolean = true;
  @Output('upload') upload: EventEmitter<FileList> =
    new EventEmitter<FileList>();
  @Input('uploading') uploading: boolean = false;
  @Input('errorMessage') errorMessage: string = '';
  @Input('success') success: boolean = false;

  public isDragOver: boolean = false;
  public id: string = 'file';

  public constructor(public env: EnvironmentService) {
    this.id += Math.random() * 100;
  }
  public hasFormData() {
    return 'FormData' in window;
  }
  public hasFileReaderApi() {
    return 'FileReader' in window;
  }
  public canDragAndDrop() {
    let div = document.createElement('div');
    return 'draggable' in div || ('ondragstart' in div && 'ondrop' in div);
  }
  public advancedUpload() {
    // this is the desired check but I don't have time to debug the dragover errors right now
    //return (
    //  this.hasFormData() && this.hasFileReaderApi() && this.canDragAndDrop()
    //);
    return false;
  }

  @HostListener('drag', ['$event'])
  @HostListener('dragstart', ['$event'])
  @HostListener('dragenter', ['$event'])
  @HostListener('dragleave', ['$event'])
  @HostListener('dragend', ['$event'])
  @HostListener('drop', ['$event'])
  @HostListener('dragover', ['$event'])
  preventPropagation(e: Event) {
    e.preventDefault();
    e.stopPropagation();
  }

  @HostListener('dragover')
  @HostListener('dragenter')
  activateIsDragOver() {
    this.isDragOver = true;
  }

  @HostListener('dragleave')
  @HostListener('dragend')
  @HostListener('drop')
  deactivateIsDragOver() {
    this.isDragOver = false;
  }

  @HostListener('drop', ['$event'])
  handleDrop(e: DragEvent) {
    if (e.dataTransfer?.files) {
      this.upload.emit(e.dataTransfer.files);
    }
  }
  @HostListener('change', ['$event.target'])
  handleSelection(target: EventTarget | null) {
    if (target instanceof HTMLInputElement && target.files) {
      this.upload.emit(target.files);
    }
  }
}
